var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7194 12.3794H13.7587C13.6837 12.3794 13.6212 12.4419 13.6212 12.5169V13.6205H2.37651V2.37407H13.6229V3.47764C13.6229 3.55264 13.6854 3.61514 13.7604 3.61514H14.7212C14.7962 3.61514 14.8587 3.55442 14.8587 3.47764V1.68835C14.8587 1.38478 14.614 1.14014 14.3104 1.14014H1.69079C1.38722 1.14014 1.14258 1.38478 1.14258 1.68835V14.3062C1.14258 14.6098 1.38722 14.8544 1.69079 14.8544H14.3087C14.6122 14.8544 14.8569 14.6098 14.8569 14.3062V12.5169C14.8569 12.4401 14.7944 12.3794 14.7194 12.3794ZM15.0515 7.88478L12.5176 5.88478C12.4229 5.80978 12.2854 5.87764 12.2854 5.99728V7.35442H6.67829C6.59972 7.35442 6.53544 7.41871 6.53544 7.49728V8.49728C6.53544 8.57585 6.59972 8.64014 6.67829 8.64014H12.2854V9.99728C12.2854 10.1169 12.4247 10.1848 12.5176 10.1098L15.0515 8.10978C15.0686 8.09642 15.0824 8.07934 15.0919 8.05985C15.1014 8.04036 15.1063 8.01896 15.1063 7.99728C15.1063 7.9756 15.1014 7.9542 15.0919 7.93471C15.0824 7.91522 15.0686 7.89814 15.0515 7.88478Z",
    fill: "#2870ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.6fcff3e96bcb1a3ea34953019778aa34.svg";
export { ForwardRef as ReactComponent };